import React from 'react';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker.scss';
import { CalendarSvgIcon } from '../assets';
import moment from 'moment';
var DateTimePicker = function (_a) {
    var time = _a.time, minDate = _a.minDate, selectedDate = _a.selectedDate, onChange = _a.onChange, maxDate = _a.maxDate, isUtc = _a.isUtc;
    var dateFormat = time ? 'MMMM d, yyyy h:mm aa' : 'dd/MM/yyyy';
    var utcOffset = moment().utcOffset();
    var changetoUtc = function (selectedDate) {
        if (!isUtc)
            return selectedDate;
        return utcOffset > 0 ?
            moment(selectedDate).subtract(utcOffset, 'minutes').toDate() :
            moment(selectedDate).add(utcOffset, 'minutes').toDate();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "inputWrapper" },
            React.createElement("label", null,
                React.createElement(DatePicker, { showTimeSelect: time, dateFormat: dateFormat, selected: changetoUtc(selectedDate), onChange: onChange, minDate: minDate, maxDate: maxDate, showYearDropdown: true, scrollableYearDropdown: true, yearDropdownItemNumber: 10 }),
                React.createElement(CalendarSvgIcon, null)))));
};
DateTimePicker.defaultProps = {
    time: false,
    minDate: false,
    maxDate: new Date(),
    isUtc: true
};
export default DateTimePicker;
